import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
type CountdownProps = {
  title?: string;
};
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown({
  title = 'This special offer expires in'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'Hours'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Sec'
  }];
  return <div className="w-full" data-id="element-88" data-mp="10d4pdocf48io">
      <p className="mb-2 text-center text-[11px] font-700 uppercase tracking-[0.2em] text-alert sm:text-xs" data-id="element-89" data-mp="15bg52fpe9d8t">
        <span className="mr-1.5 inline-block h-2 w-2 animate-pulse-soft rounded-full bg-alert align-middle" data-id="element-90" data-mp="y0wrfchtfgg9" />
        {title}
      </p>
      <div className="flex items-stretch justify-center gap-2" role="timer" aria-live="off" aria-label={`Offer expires in ${pad(hours)} hours ${pad(minutes)} minutes ${pad(seconds)} seconds`} data-id="element-91" data-mp="t1ai3e53ykcq">
        {blocks.map(block => <div key={block.label} className="min-w-[74px] rounded-lg border border-white/10 bg-navy-900 px-3 py-2 text-center sm:min-w-[86px]" data-id="element-92" data-mp="f1somlgvaix1">
            <span className="block font-display text-3xl font-700 tabular-nums text-white sm:text-4xl" data-id="element-93" data-mp="o30mj2fh1hql">
              {block.value}
            </span>
            <span className="block text-[10px] font-600 uppercase tracking-[0.18em] text-slate-400" data-id="element-94" data-mp="k0m4gkjmmm0d">
              {block.label}
            </span>
          </div>)}
      </div>
    </div>;
}